// removed by extract-text-webpack-plugin
module.exports = {"dot":"Loader__dot__1A6ti","mymove":"Loader__mymove__1467Z","loader":"Loader__loader__1rFlH"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Loader/Loader.css
// module id = 326
// module chunks = 0